// istanbul ignore next reason: no need to test
export const stopMediaStreamTracks = (stream: MediaStream) => {
  const tracks = stream.getTracks();
  if (Array.isArray(tracks)) {
    for (const track of tracks) {
      track.stop();
    }
  }
};

// istanbul ignore next reason: hard to test
export const hasFrontBackCamera = async (): Promise<boolean> => {
  const result = { hasBack: false, hasFront: false };
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
    const devices = await navigator.mediaDevices.enumerateDevices();
    devices.filter(device => {
      if (device.kind === 'videoinput') {
        if (device.label && device.label.length > 0) {
          if (device.label.toLowerCase().indexOf('back') >= 0) {
            result.hasBack = true;
          } else if (device.label.toLowerCase().indexOf('front') >= 0) {
            result.hasFront = true;
          }
        }
        return true;
      }
      return false;
    });
    stopMediaStreamTracks(stream);
    return result.hasBack && result.hasFront;
  } catch (ex) {
    return false;
  }
};
